import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = {
  key: 0,
  class: "header"
}
const _hoisted_4 = {
  key: 0,
  class: "subheader"
}
const _hoisted_5 = {
  key: 1,
  class: "image"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 0,
  class: "text"
}
const _hoisted_8 = {
  key: 2,
  class: "features"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "link"
}
const _hoisted_11 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedbackForm = _resolveComponent("FeedbackForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.getField('header'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getField('header')?.prefix || '') + _toDisplayString(_ctx.resolveDisplayValue(_ctx.getField('header'), _ctx.item?.[_ctx.getField('header')?.key || ''])), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fas fa-times" }, null, -1)
      ]))])
    ]),
    (_ctx.getField('subheader'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.resolveDisplayValue(_ctx.getField('subheader'), _ctx.item?.[_ctx.getField('subheader')?.key || ''])), 1))
      : _createCommentVNode("", true),
    (_ctx.getField('image') && _ctx.item?.[_ctx.getField('image')?.key || ''])
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.item?.[_ctx.getField('image')?.key || ''],
            alt: _ctx.getField('image')?.key
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFields, (field) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: field.key
      }, [
        (_ctx.item?.[field.key])
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("strong", null, _toDisplayString(field.defaultText || field.key) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.resolveDisplayValue(field, _ctx.item?.[field.key])), 1)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.item?.features?.items?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.features.items, (feature) => {
            return (_openBlock(), _createElementBlock("div", {
              key: feature.key
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", _ctx.getIconClass(feature.icon)]),
                style: _normalizeStyle({ color: feature.color }),
                title: feature.key
              }, null, 14, _hoisted_9),
              _createElementVNode("span", null, _toDisplayString(feature.prefix || '') + _toDisplayString(feature.value) + _toDisplayString(feature.suffix || ''), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFieldsByType('link'), (field) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: field.key
      }, [
        (_ctx.isValidUrl(_ctx.item?.[field.key]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", {
                href: _ctx.item?.[field.key],
                target: field.target || '_blank'
              }, _toDisplayString(field.defaultText || _ctx.item?.[field.key]), 9, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.feedbackField && _ctx.item?.formId && _ctx.item?.id)
      ? (_openBlock(), _createBlock(_component_FeedbackForm, {
          key: 3,
          formId: _ctx.item.formId,
          recordId: _ctx.item.id,
          targetField: _ctx.feedbackField.key
        }, null, 8, ["formId", "recordId", "targetField"]))
      : _createCommentVNode("", true)
  ]))
}